import React from "react";
import { CustomBreadcrumb } from "../../components";
import { DIRECT_DEBIT_CONSTANTS } from "../../config/constants";
import { DirectDebitStyled } from "./styled";
import DirectDebitList from "./DirectDebitList";

const DirectDebit = () => {
  return (
    <CustomBreadcrumb
      header={DIRECT_DEBIT_CONSTANTS.HEADER}
      currentPage={DIRECT_DEBIT_CONSTANTS.BREADCRUMB_DIRECT_DEBIT}
      isFromLandingPage={false}
    >
      <DirectDebitStyled>
        <DirectDebitList />
      </DirectDebitStyled>
    </CustomBreadcrumb>
  );
};

export default DirectDebit;
